<template>
  <div >
    <section>
      <img class="banner" :src="banner" alt="">
    </section>
    <section class="content_style">
      <div class="tab">
        <p class="total-width">
          <span>
            <span 
            class="year_name_tit"
            :class="styleType==='team'&&'active'" 
            @click="styleType='team'">
            团队风采<span>{{this.activeYear}}</span>
            </span>
          </span>
          <span>
            <span
            class="year_name_tit"
            :class="styleType==='person'&&'active'" 
            @click="styleType='person'">
            个人风采<span>{{this.activeYear}}</span>
            </span>
          </span>
        </p>
      </div>
      <!-- <div class="years">
        <ul class="total-width">
          <li v-for="(item,index) in years" :key="item.id">
            <span class="click_year" :class="item.year==='2022'&&'active_year'">{{item.year}}</span>
            <span class="line" v-if="index!==years.length-1">
              <span></span>
            </span>
          </li>
        </ul>
      </div> -->
      <div class="content">
        <!-- 团队风采 -->
        <ul class="total-width team_content" v-if="styleType==='team'">
          <li v-for="(item,index) in teamstyle['year_'+this.activeYear].fineTeam.dataList" :key="item.id" :class="(index+1)%3===0&&'mr-0'">
            <viewer :images="[item.img]">
              <img :src="item.img" alt="" @contextmenu.prevent="(e)=>e.preventDefault()">
            </viewer>
            <div class="team_intro intro">
              <p class="names"><span>团队名称：{{item.name}}</span></p>
              <p class="bottom_line"><span></span></p>
              <p class="year_glory">当年荣誉：{{item.glory}}</p>
              <p class="motto">团队格言：{{item.motto}}</p>
            </div>
          </li>
        </ul>
        <!-- 个人风采 -->
        <ul class="total-width person_content" v-if="styleType==='person'">
          <li v-for="(item,index) in personstyle['year_'+this.activeYear]" :key="index">
            <p>
              <img :src="require(`@/assets/images/staffstyle/${item.typeKey}.png`)" alt="">
            </p>
            <div class="person_swiper">
              <swiper :ref="'mySwiper'+item.typeKey" :options="swiperOptionsFun(item.typeKey)">
                <swiper-slide v-for="v in item.dataList" :key="v.id">
                    <div>
                      <viewer :images="[v.img]">
                        <img class="person_img" :src="v.img" @contextmenu.prevent="(e)=>e.preventDefault()"/>
                      </viewer>
                      <div class="person_intro intro">
                        <p class="names"><span>岗位：{{v.job}}</span></p>
                        <p class="bottom_line"><span></span></p>
                        <p class="seniority">司龄：{{v.seniority}}</p>
                        <p class="year_glory">年度荣誉：{{v.glory}}</p>
                        <p class="motto">人生格言：{{v.motto}}</p>
                      </div>
                    </div>
                </swiper-slide>
              </swiper>
              <div
                  class="swiper-button-prev swiper-button-black"
                  :class="item.typeKey+'_prev'"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next swiper-button-black"
                  :class="item.typeKey+'_next'"
                  slot="button-next"
                ></div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import {allStaffStyle} from '@/common/util/staffStyleData.js'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
export default {
  components: { swiper, swiperSlide },
  data(){
    return{
      ...allStaffStyle,
      years:[],
      activeYear:'2022',
      styleType:"team",
      swiperOptions: {
        grabCursor: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      dialogVisible:false,
      imageUrl:''
    }
  },
  mounted(){
    this.filerYear()
    
  },
  methods:{
    swiperOptionsFun(key){
      return {
        ...this.swiperOptions,
        navigation:{
          nextEl:'.'+key+'_next',
          prevEl:'.'+key+'_prev'
        }
      }
    },
    filerYear(){
      for(let key in this.teamstyle){
        const year = key.replace('year_','')
        this.years.push({
          id:year,
          year,
        })
      }
    }
  }
}
</script>
<style lang="less">
.viewer-canvas{
  img{
    // 禁止图片保存
    pointer-events: none !important;
  }
}
</style>
<style lang="less" scoped>
.banner{
  width: 100%;
}
.active{
  border-bottom: 2px solid #CD3324;
  color: #CD3324;
  >span{
    background-image: url('~@/assets/images/staffstyle/year_bg_active.png') !important;
  }
}
.mr-0{
  margin-right: 0 !important;
}
.active_year{
  color: #fff !important;
  background: #CD3324;
  border-radius: 16px;
}
.content_style{
  width: 100%;
  .tab{
    width: 100%;
    line-height: 68px;
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06);
    >p{
      display: flex;
      justify-content: space-between;
      >span{
      width: 50%;
      text-align: center;
        >span{
          font-size: 18px;
          font-weight: 600;
          padding-bottom: 17px;
          cursor: pointer;
          span{
            display: inline-block;
            width: 66px;
            margin-left: 10px;
            background: url('~@/assets/images/staffstyle/year_bg.png') no-repeat;
            background-size: 66px 19px;
            background-position: 50%;
          }

        }
    }
    }
  }
  .years{
    width: 100%;
    line-height: 68px;
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06);
    border-bottom: 1px dashed #666666;
    ul{
      display: flex;
      justify-content: flex-start;
      li{
        >span{
          font-size: 16px;
          font-weight: 600;
          line-height: 32px;
          display: inline-block;
        }
        .click_year{
          color: #666666;
          width: 80px;
          // padding: 8px 16px;
          text-align: center;
          cursor: pointer;
        }
        .line{
          width: 100px;
          text-align: center;
          padding: 0 8px;
          >span{
            display: inline-block;
            height: 2px;
            width: 100%;
            background: #FE3838;
            margin-bottom: 3px;
          }
        }
      }
    }

  }
  .content{
    width: 100%;
    padding-top: 40px;
    background: url('~@/assets/images/staffstyle/bg_content.png') no-repeat;
    background-size: 100% 100%;
    .team_content{
      display: flex;
      flex-wrap:wrap;
      justify-content: flex-start;
      li{
        width: 31%;
        // height: 452px;
        background: #fff;
        margin: 0 40px 40px 0;
        border-radius: 0 0 5px 5px;
        img{
          border-radius: 5px 5px 0 0;
          width: 100%;
          cursor: pointer;
          // height: 266px;
        }
        .team_intro{
          width: 100%;
          height: 186px;
          padding: 10px 30px 30px 20px;
        }
      }
    }
    .person_content{
      width: 100%;
      li{
        width: 100%;
        // height: 490px;
        // margin-bottom: 80px;
        >p{
          height: 50px;
          margin: 0 15px;
          background-color: #CD3324;
          margin-bottom: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          >img{
            height: 22px;
          }
        }
        .person_swiper{
          position: relative;
          .swiper-button-prev,
            .swiper-button-next {
              position: absolute;
              width: 80px;
              height: 80px;
              top: 200px;
            }
            .swiper-button-prev.swiper-button-black,
            .swiper-container-rtl .swiper-button-next.swiper-button-black {
              background-image: url("~@/assets/images/staffstyle/btn_left.png");
              background-size: 100%;
              left: -110px;
            }
            .swiper-button-next.swiper-button-black,
            .swiper-container-rtl .swiper-button-prev.swiper-button-black {
              background-image: url("~@/assets/images/staffstyle/btn_right.png");
              background-size: 100%;
              right: -110px;
            }
            .swiper-button-prev.swiper-button-disabled {
              opacity: 1;
              background-image: url("~@/assets/images/staffstyle/btn_left_d.png");
            }
            .swiper-button-next.swiper-button-disabled {
              opacity: 1;
              background-image: url("~@/assets/images/staffstyle/btn_right_d.png");
            }
          .swiper-container {
            padding-bottom: 80px;
            ::v-deep .swiper-slide{
              width: calc(25% - 30px) !important;
              margin: 0 15px;
              >div{
                position: relative;
                .person_intro{
                  // width: 270px;
                  width: 100%;
                  height: 230px;
                  position: absolute;
                  bottom: 0;
                  padding: 18px 30px 19px 30px;
                }
              }
            }
            
          }
          .person_img{
            // width: 270px;
            width: 100%;
            // height: 420px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.intro{
  border-radius: 0 0 5px 5px;
  background: linear-gradient(180deg, #F1F1F1 0%, #FBFBFB 100%) #FFFFFF;
  box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.05);
  .names{
    height: 63px;
    font-size: 18px;
    line-height: 32px;
    color: #CD3324;
    font-weight: 600;
    // display: flex;
    // justify-content: flex-start;
    // align-items: center;
  }
  .bottom_line span{
    display: inline-block;
    width: 30px;
    height: 4px;
    background: #CD3324;
    border-radius: 3px 0 3px 0;
    margin-bottom: 6px;
  }
  .seniority,
  .year_glory,
  .motto{
    margin-top: 10px;
    font-size: 14px;
    color: #666666;
  }
}
</style>